// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__HnBDM","logoContainer":"Sidebar_logoContainer__PBdYz"};